import { render, staticRenderFns } from "./EmailSettingsPage.vue?vue&type=template&id=6851b983"
import script from "./EmailSettingsPage.vue?vue&type=script&lang=ts"
export * from "./EmailSettingsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6851b983')) {
      api.createRecord('6851b983', component.options)
    } else {
      api.reload('6851b983', component.options)
    }
    module.hot.accept("./EmailSettingsPage.vue?vue&type=template&id=6851b983", function () {
      api.rerender('6851b983', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/admin/EmailSettingsPage.vue"
export default component.exports